import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router';

import {AppRoutes} from './app.routing';

import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import {ClickOutsideModule} from 'ng-click-outside';
import {SharedModule} from './shared/shared.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BreadcrumbsComponent} from './layout/admin/breadcrumbs/breadcrumbs.component';
import {TitleComponent} from './layout/admin/title/title.component';
import {AuthComponent} from './layout/auth/auth.component';


import {HttpClientModule} from '@angular/common/http';


import { AuthentificationService } from './services/authentification.service';

import {User} from './models/user';
import {Projet} from './models/projet';
import {Profil} from './models/profil';
import {Pole} from './models/pole';
import {Tache} from './models/tache';
import {Reunion} from './models/reunion';
import {Direction} from './models/direction';
import {Ged} from './models/ged';

import {ToastyModule} from 'ng2-toasty';



@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    BreadcrumbsComponent,
    TitleComponent,
    AuthComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes),
      ToastyModule.forRoot(),
    ClickOutsideModule,
    SharedModule,
      HttpClientModule
  ],
    providers: [
        AuthentificationService,
        User,
        Projet,
        Profil,
        Pole,
        Tache,
        Reunion,
        Direction,
        Ged
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/app.module.ts